import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@polichat/flamboyant';

import styles from './style.module.css';
import { IconPlusIcon } from '../../../../../assets/illustratorElement/iconPlusIcon/iconPlusIcon';
import Animation from 'src/components/common/animation';

interface ZapiModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function LeadsModal({
  isOpen,
  isLoading,
  onClose,
  onSubmit,
}: ZapiModalProps): JSX.Element {
  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose}>
        <ModalHeader>
          <div className={styles.image_header}>
            <IconPlusIcon
              firstIcon="onlyLogo"
              secondIcon="metaIcon"
              secondColor="var(--success)"
            />
            Integração Com API de Marketing
          </div>
        </ModalHeader>
        <ModalBody className={styles.modal_body}>
          Deseja desconectar sua conta de anúncios?
        </ModalBody>
        <ModalFooter>
          <div className={styles.buttons_container}>
            <Button
              style={{
                minWidth: '100px',
                minHeight: '40px',
              }}
              disabled={isLoading}
              gradient="danger"
              className={styles.custom_button}
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              style={{
                minWidth: '100px',
                minHeight: '40px',
              }}
              disabled={isLoading}
              className={styles.custom_button}
              onClick={onSubmit}
            >
              {isLoading ? (
                <Animation
                  icon="loading"
                  style={{
                    borderColor: 'var(--menus-background-sidebar-color)',
                  }}
                  size="minorLittleTiny"
                  color="var(--white)"
                />
              ) : (
                'Continuar'
              )}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}
